import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import { Dropdown, Dialog } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Dropdown).use(Dialog)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
